<!--<div class="app-gdpr-wrap {{gdprStatus}}" [ngClass]="{'open':gdprStatus==='open'}" *ngIf="gdprStatus==='open'">-->
<div class="app-gdpr-wrap {{gdprStatus}}">
  <div class="common-back-btn blue" (click)="close()">
    <i class="fa fa-angle-left icon"></i>
  </div>
  <div class="gdpr-content">
    <div class="gdpr-pic-wrap"><img src="{{assetsRoute}}/picture/menu-bar/GDPR-lg.png" alt=""></div>
    <p>DDI 致力于在整个运营过程中遵守《中华人民共和国个人信息保护法》《通用数据保护条例》(General Data Protection Regulation)等相关个人信息保护领域的法律法规, 并致力于向每一位用户提供合规服务, 如果您有以下需求，包括：</p>
    <ul>
      <li>查阅、复制或转移个人信息</li>
      <li>更正、补充个人信息</li>
      <li>删除、限制或拒绝处理个人信息</li>
    </ul>
    <p>请点击下方“个人信息处理请求表”按钮填写您的个人信息处理请求，我们将在3个工作日内对您的个人信息处理请求做出响应。</p>
  </div>
  <component-button [theme]="buttonTheme" [isDisabled]="false" (onCommit)="submit()"></component-button>
</div>



// WEBPACK FOOTER //
// ./src/app/app-gdpr/app-gdpr.component.html